import { SVGProps } from "react";

export default function DashboardInfoIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 14, width = 14, stroke = "#B0B2B5", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#dashboardInfoIconClip)">
        <path
          d="M6.99935 9.33317V6.99984M6.99935 4.6665H7.00518M12.8327 6.99984C12.8327 10.2215 10.221 12.8332 6.99935 12.8332C3.77769 12.8332 1.16602 10.2215 1.16602 6.99984C1.16602 3.77818 3.77769 1.1665 6.99935 1.1665C10.221 1.1665 12.8327 3.77818 12.8327 6.99984Z"
          stroke={stroke}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="dashboardInfoIconClip">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
